<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_vii"></a>NOTHING<br/>LEFT TO<br/>FEAR FROM<br/>HELL</h1>
<p class="subtitle"><em>A Surreal Chronicle</em></p>
<p class="author">Alan Warner</p>
<p class="pub"><img alt="Illustration" src="images/pub.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4994e712